import React, { ReactElement } from 'react';
import { TournamentsBtnLeave } from './tournamentsBtnLeave/tournamentsBtnLeave';

export const TournamentsHeader = (): ReactElement => {
  return (
    <header className="tournaments-header">
      <div className="tournaments-header__btn-leave">
        <TournamentsBtnLeave />
      </div>
    </header>
  );
};
